///<reference path="../../../../node_modules/@angular/core/src/metadata/lifecycle_hooks.d.ts"/>
import {Component, NgZone, OnDestroy, OnInit} from "@angular/core";
import {SessionService} from "../../core/session.service";
import {Router} from "@angular/router";
import {NavigationService} from "./navigation.service";
import {Location} from "@angular/common";
import {Subscription} from "rxjs/Subscription";
import {CookieOptions, CookieService} from "ngx-cookie";
import {GAService} from "../ga/ga.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'sara-header',
    templateUrl: './sara-header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
    // TODO: La implementacion del menu hoy no mantiene el estado en los sublinks, para simplificarlo se deja activo el link principal, repensar como hacer esto para que quede limpio
    selectedLink:string="";
    companyToRepresent:boolean;

    private subscriptions: Subscription[] = [];

    companyOid: number;
    companyName: string;

    constructor(private sessionService: SessionService,
                private router: Router,
                private navigationService: NavigationService,
                private location: Location,
                private zone:NgZone,
                private _cookieService: CookieService,
                private gaService: GAService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.subscriptions.push(this.sessionService
            .getCleanCompanySubject()
            .subscribe(val => this.cleanCompany()));
        this.subscriptions.push(this.sessionService
            .getCompanyToRepresentSubject()
            .subscribe(val => this.setCompanyInfo()));
        this.subscriptions.push(this.navigationService
            .getSectionSubject()
            .subscribe(val => {this.zone.run(() => { this.selectedLink = val }) }));

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    getCompanyOid(): number | undefined {
        return this.companyOid;
    }

    hasCompanyToRepresent(): boolean {
        return this.sessionService.hasCompanyToRepresent();
    }

    getCompanyName(): string | undefined {
        return this.companyName;
    }

    getUserName(): string {
        if (this.sessionService.getUserSession()) {
            return this.sessionService.getUserSession().userLabel;
        }
        return undefined;
    }

    logoNavigate() {
        if (this.sessionService.getUserSession()) {
            let userSession = this.sessionService.getUserSession();
            if (userSession.userType === "COMPANY") {
                this.navigate("home");
            } else {
                this.navigate("impersonate")
            }
        }
    }

    navigate(section: string) {
        let url;
        try {
            url = this.navigationService.getHref(section, this.getCompanyOid());
        } catch (e) {
            console.error("Problems while getting url to navigate", e);
            return;
        }
        this.router.navigateByUrl(url)
            .then(result => {
                if (!result) {
                    console.debug("Router navigation failed. Using Location service to navigate.");
                    this.location.go(url);
                }
            })
            .catch(error => console.error("navigation error: ", error));
    }

    isActiveMenu(name: string): boolean {
        return this.navigationService.isActiveMenu(name);
    }

    getNavConfig(): any {
        return this.navigationService.getNavConfig();
    }

    private setCompanyInfo() {
        this.zone.run(() => {
            this.companyName = this.sessionService.getUserSession().companyName;
            this.companyOid = this.sessionService.getUserSession().companyOid;
            this.companyToRepresent = true;
        });

    }

    private cleanCompany() {
        this.zone.run(() => {
            this.companyOid = undefined;
            this.companyName = undefined;
            this.companyToRepresent = false;
        });

    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/sara-header/sara-header.component.ts